import { createSelector } from 'reselect'

import routes from 'router/routes'
import findRoute from 'router/utils/findRoute'

import {
  route,
  routeParams,
  routeParamId,
  prop,
  previousRoute,
} from './utils'

const name = prop(route, 'name')
const segments = createSelector(
  route,
  currentRoute => currentRoute.name.split('.'),
)

export default {
  route,

  previousRoute,

  fullRoute: (state) => findRoute(routes, name(state)),

  /*
  
    get the current route name
  
  */
  name,

  /*
  
    get the current route params
  
  */
  params: routeParams,
  idParam: routeParamId,

  /*
  
    split the current route name by period
    so if the current route name is 'content.books.1'
    it returns ['content', 'books', 1]
  
  */
  segments,
  /*
  
    get a single segment of the route based on index
    so if the current route name is 'content.books.1'
    index of 1 would return 'books'
  
  */
  segment: (state, index) => segments(state)[index],
  /*
  
    get a single segment of the route that is after the given segment
    so if the current route name is 'content.books.1'
    segment of 'content' would return 'books'
  
  */
  segmentAfter: (state, segment) => {
    const parts = segments(state)
    const segmentIndex = parts.indexOf(segment)
    if(segmentIndex < 0) return null
    return parts[segmentIndex + 1]
  },
}
